import React, { Component } from 'react';
import { Button } from 'reactstrap';
import { DisplayPayBtnText, DisplayConvFee, DisplayConvFeeDiscription, GoBack } from 'components/Common'
import StandingInstructionModal from "components/FDModal/standing-instruction";
import CurrencyConversionModal from "components/FDModal/currency_conversion";

class SIBtnORBtn extends Component {

    toggleStandingInst = this.toggleStandingInst.bind(this);
    toggleCurrencyConversion = this.toggleCurrencyConversion.bind(this);
    triggerSISubmitForm = this.triggerSISubmitForm.bind(this);
    payBtnType = this.payBtnType.bind(this);
    state = { canDisplayStandingInst: false, canDisplayCurrencyConversion: false }

    toggleStandingInst(){
        this.setState(prevState => ({canDisplayStandingInst: !prevState.canDisplayStandingInst}))
    }

    toggleCurrencyConversion(){
        this.setState(prevState => ({canDisplayCurrencyConversion: !prevState.canDisplayCurrencyConversion}))
    }

    triggerSISubmitForm(){
        document.getElementById("SISubmitBtn").click()
    }

    triggerCurrencyConversionSubmitForm(){
        document.getElementById("CurrencyConversionSubmitBtn").click()
    }

    payBtnType(type){
        const { dccEnabled, siEnabled, from } = this.props
        if(type==='dcc'){
            return dccEnabled
        }else if(type==='si'){
            return !dccEnabled && siEnabled  && !(from==='IDC' || from==='EMISC' || from==='EMIC')
        }else if(type==='default'){
            return !(dccEnabled || (!dccEnabled && siEnabled  && !(from==='IDC' || from==='EMISC' || from==='EMIC')))
        }
    }

    render() {
        const { t, change, untouch, from, cardMetaData, formValues, disabled, btnName, transactionDetails, dccCard, touch,errorMessage } = this.props;
        const classes = {

        }
        return(
            <>
                {/* { 
                    this.payBtnType('si') && this.state.canDisplayStandingInst && 
                    <StandingInstructionModal modalClassName="custom-popup custom-digit-popup"
                        toggleStandingInst={this.toggleStandingInst}
                        submitDisabled={disabled}
                        t={t}
                        touch={touch}
                        change={change}
                        untouch={untouch}
                        submitForm={this.triggerSISubmitForm}
                        formValues={formValues}
                        transactionDetails={transactionDetails}
                    />
                } */}
                { 
                    this.payBtnType('dcc') && this.state.canDisplayCurrencyConversion && 
                    <CurrencyConversionModal modalClassName="custom-popup"
                        toggleCurrencyConversion={this.toggleCurrencyConversion}
                        submitDisabled={disabled}
                        dccCard={dccCard}
                        t={t}
                        change={change}
                        untouch={untouch}
                        submitForm={this.triggerCurrencyConversionSubmitForm}
                        formValues={formValues}
                        transactionDetails={transactionDetails}
                    />
                }
                <DisplayConvFee cardMetaData={cardMetaData} t={t}/>
                {errorMessage &&
                       <div className='error mb-2'>{errorMessage}</div>
                }
                {
                    this.payBtnType('dcc') &&
                    <>
                        <Button className='btn' disabled={disabled} onClick={this.toggleCurrencyConversion}>
                        { 
                            from==='EMIC' ?
                            <p className='text-center m-0'>{ t('Proceed') }</p>
                            :
                            <DisplayPayBtnText cardMetaData={cardMetaData} transactionDetails={transactionDetails} t={t}  selectedEMIOption={this.props.selectedEMIOption}/>
                        }
                        </Button>
                        <Button disabled={disabled} className="hidden" id="CurrencyConversionSubmitBtn">Submit</Button>
                    </>
                }
                {
                    this.payBtnType('si') &&
                    <>
                         <StandingInstructionModal modalClassName="custom-popup custom-digit-popup"
                        toggleStandingInst={this.toggleStandingInst}
                        submitDisabled={disabled}
                        t={t}
                        touch={touch}
                        change={change}
                        untouch={untouch}
                        submitForm={this.triggerSISubmitForm}
                        formValues={formValues}
                        transactionDetails={transactionDetails}
                    />
                        <Button disabled={disabled} className="hidden" id="SISubmitBtn">Submit</Button>
                    </>
                }
                {
                    this.payBtnType('default') &&
                    <Button disabled={disabled} className="btn">
                        {
              
                            btnName ? <span>{btnName}</span> : <DisplayPayBtnText cardMetaData={cardMetaData}
                            emiCurrency={this.props.emiCurrency}
                            selectedEMIOption={this.props.selectedEMIOption}
                            transactionDetails={transactionDetails} t={t} />
                        }
                    </Button>
                }
                <DisplayConvFeeDiscription cardMetaData={cardMetaData} t={t}/>
                {
                    this.props.backLink && 
                    <div className="go-back-site text-center">
                        <GoBack t={t}/>
                    </div>
                }
            </> 
        );
    }
}

export default SIBtnORBtn;